import { IsInt, IsOptional, IsString } from 'class-validator';

export class UpdateContactInformationDto {
  @IsOptional()
  @IsString()
  postalCode?: string;

  @IsOptional()
  @IsInt()
  provinceId?: number;

  @IsOptional()
  @IsInt()
  cityId?: number;

  @IsOptional()
  @IsString()
  avenue?: string;

  @IsOptional()
  @IsString()
  alley?: string;

  @IsOptional()
  @IsString()
  plaque?: string;

  @IsOptional()
  @IsString()
  phoneNumber?: string;
}
